import { Icon, IconProps, SemanticICONS } from "semantic-ui-react";
import { TreeNodeSelection } from "./AccessorTreeNode";

interface CheckboxIconProps extends IconProps {
	variant: TreeNodeSelection;
}

export default function CheckboxIcon({ variant, ...forward }: CheckboxIconProps) {
	let name: SemanticICONS;

	switch (variant) {
		case "all":
			name = "check square outline";
			break;

		case "none":
			name = "square outline";
			break;

		case "some":
			name = "minus square outline";
			break;

		default:
			throw new Error("Unexpected state");
	}

	return <Icon name={name} {...forward} />;
}
